const ANALYTICS_TAGS = [
  'og_ref',
  'utm_medium',
  'utm_source',
  'utm_campaign',
  'utm_content',
  'utm_term',
];

export const extractTrackingTags = (queryParams?: object) =>
  Object.fromEntries(
    Object.entries(queryParams ?? {}).filter(([key]) =>
      ANALYTICS_TAGS.includes(key)
    )
  );
